import type { MouseEvent } from "react";
import styled from "styled-components";

interface SwapArrowProps {
  isReversed: boolean;
  onClick: () => void;
}

export const SwapArrow = ({ isReversed, onClick }: SwapArrowProps) => {
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <ArrowContainer>
      <ArrowButton
        onClick={handleClick}
        type="button"
        aria-label={isReversed ? "Swap direction up" : "Swap direction down"}
      >
        <ArrowIcon
          viewBox="0 0 24 24"
          $isReversed={isReversed}
          fill="none"
          stroke="white"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 14l-7 7m0 0l-7-7m7 7V3"
          />
        </ArrowIcon>
      </ArrowButton>
    </ArrowContainer>
  );
};

const ArrowContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin: 0px 0px -8px 0;
`;

const ArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #333333;
  background: transparent;
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: rgba(51, 51, 51, 0.5);
  }
`;

const ArrowIcon = styled.svg<{ $isReversed: boolean }>`
  width: 24px;
  height: 24px;
  transition: transform 0.2s;
  transform: ${({ $isReversed }) =>
    $isReversed ? "rotate(180deg)" : "rotate(0deg)"};
`;
